import React from 'react'
import { useSelector } from 'react-redux'
import Trns from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'

interface AppNameProps {}

/** @deprecated
 * Use `const appName = useSelector(selectAppName); translate(appName)` instead. Do not use this component
 */
const AppName: React.FC<AppNameProps> = (): React.ReactElement => {
  const appName = useSelector(selectAppName)

  return <Trns source={appName} />
}

export default AppName
